import Result from "@/core/common/Result";
import {
  IPesquisaCSATAtivaGateway,
  PesquisaCSATAtivaParams,
  PesquisaCSATAtivaResponse
} from "../ports/PesquisaCSATAtivaGateway";
import { ContabilGatewayError } from "@/features/contabil/diagnostico/config/ContabilGatewayError";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";

@injectable()
export class PesquisaCSATAtivaGatewayAdapter
  extends ContabilGatewayError
  implements IPesquisaCSATAtivaGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly cliente!: HttpClient;

  async pesquisaAtiva(
    params: PesquisaCSATAtivaParams
  ): Promise<Result<PesquisaCSATAtivaResponse>> {
    try {
      const response = await this.cliente.get<
        IDefaultContabilResponse<PesquisaCSATAtivaResponse>
      >({
        url: "contabil/v1/pesquisa/exibir",
        queryParams: params
      });

      if (this.hasError(response)) return Result.fail("Nenhuma pesquisa ativa");

      return Result.ok(response.body?.result);
    } catch {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
